import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PriceRankPipe } from '../../../../pipes/prices.pipe';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MaterialSelect2Service } from '../../../../modules/@material-input/component/material-select2.service';
import { NotificationService } from '../../../../services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '../../../../services/http.service';
import { DictionariesService } from '../../../../services/dictionaries.service';

@Component({
    selector: 'app-flat-conditions',
    templateUrl: './flat-conditions.component.html',
    styleUrls: ['./flat-conditions.component.scss'],
    standalone: false
})
export class FlatConditionsComponent implements OnInit, OnDestroy {

  private paramSubscribe: Subscription;
  private dataSubscribe: Subscription;
  public data: any = null;
  public flat_statuses = [];
  public form: UntypedFormGroup;
  @Input() public flatId = null;
  public loading = true;

  constructor(public activeRoute: ActivatedRoute, public fb: UntypedFormBuilder, public http: HttpClient,
              public notify: NotificationService, public priceRank: PriceRankPipe,
              private dict_helper: DictionariesService) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      'flat_voznagr_agenta': [],
      'flat_voznagr_agenta_from_ddu': [],
      'flat_dolya_subagenta_db': [],
      'flat_dolya_subagenta_agd': [],
      'flat_srok_realisation': [],
      'flat_status_id': [],
    });

    if (this.flatId) {
      this.getData();
    }
  }

  getData() {
    this.http.resolvers({
      'data': this.http.post('Flat.get', {'realty_id': +this.flatId, 'tab': 'conditions'}),
      'dict_flat_statuses': this.dict_helper.get('Dict.get_flat_statuses'),
    }).then((resolvers) => {
      this.data = resolvers['data'];
      this.flat_statuses = resolvers['dict_flat_statuses'];
      this.pathForm();
      this.loading = false;
    });
  }

  pathForm() {
    this.form.patchValue({
      'flat_voznagr_agenta': this.data['flat_voznagr_agenta'],
      'flat_voznagr_agenta_from_ddu': this.data['flat_voznagr_agenta_from_ddu'],
      'flat_dolya_subagenta_db': this.data['flat_dolya_subagenta_db'],
      'flat_dolya_subagenta_agd': this.data['flat_dolya_subagenta_agd'],
      'flat_srok_realisation': this.data['flat_srok_realisation'],
      'flat_status_id': '' + this.data['flat_status_id'],
    });
  }

  saveForm() {
    if (!this.form.valid) {
      this.onError('Заполните обязательные поля');
      return false;
    }
    let data = {'conditions': this.form.value};
    this.http.post('Flat.update_flat', {'realty_id': +this.flatId, 'data': data}).subscribe(
      (response) => this.onSuccess(response),
      (error) => this.onError(error)
    );
  }

  onSuccess(response) {
    this.notify.notifySuccess('Поздравляем', 'Данные успешно сохранены', 3000);
  }

  onError(error) {
    this.notify.notifyError('Ошибка', error, 5000);
  }

  ngOnDestroy() {
    if (this.paramSubscribe) {
      this.paramSubscribe.unsubscribe();
    }
    if (this.dataSubscribe) {
      this.dataSubscribe.unsubscribe();
    }
  }

}
